import axios from 'axios'
import config from './config'

let service = {}
let api = axios.create({
  baseURL: config.BASEURL
})

service.login = function (user, pass) {
  const datos = {
    user: user,
    pwd: pass
  }
  return api.post('/api/users/login', datos).then(res => res).catch(err => {
    return err.response
  })
}

export default service
